import { render, staticRenderFns } from "./IncomeManage.vue?vue&type=template&id=27ad2073&scoped=true"
import script from "./IncomeManage.vue?vue&type=script&lang=js"
export * from "./IncomeManage.vue?vue&type=script&lang=js"
import style0 from "./IncomeManage.vue?vue&type=style&index=0&id=27ad2073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad2073",
  null
  
)

export default component.exports